import { jsx as _jsx } from "react/jsx-runtime";
import { useIsUserAuthenticatedQuery } from "../../generated/generated-models";
import { Loading } from "../lib/components/Loading";
import { Navigate } from "react-router-dom";
import { clientConfigFn } from "clientConfig";
import { hasMultipleActiveSessions } from "app/authentication/ActiveSessions/sessionUtilities";
import { PageContainer } from "app/components/PageContainer";
/** Redirects to login/password/etc when attempting to access a private page */
const PrivateRoute = (props) => {
    const { data, loading } = useIsUserAuthenticatedQuery();
    if (loading) {
        return (_jsx(PageContainer, { children: _jsx(Loading, {}) }));
    }
    const isOnPath = (path, location) => {
        return location?.pathname?.indexOf(path) >= 0;
    };
    const isAuthenticated = data?.userSession?.CurrentSession?.Id !== undefined;
    const shouldRedirectToChangePassword = () => {
        return (isAuthenticated &&
            !shouldRedirectToAcceptTerms() &&
            data?.userSession?.HasTempPassword === true);
    };
    const shouldRedirectToAcceptTerms = () => {
        return (isAuthenticated &&
            !data?.userSession?.LastTermsAcceptance &&
            clientConfigFn().showTermsAndConditions);
    };
    /** Returns undefined if user can access page returns path to redirect page */
    const getPathname = () => {
        if (!isAuthenticated) {
            return "/security/login";
        }
        if (shouldRedirectToAcceptTerms()) {
            if (isOnPath("firsttimelogin", window.location)) {
                return undefined;
            }
            return "/security/acceptterms";
        }
        if (shouldRedirectToChangePassword()) {
            if (isOnPath("changepassword", window.location)) {
                return undefined;
            }
            return "/security/changepassword";
        }
        if (hasMultipleActiveSessions(data?.userSession)) {
            if (isOnPath("activesessions", window.location)) {
                return undefined;
            }
            return "/security/activesessions";
        }
        return undefined;
    };
    const pathName = getPathname();
    if (pathName === undefined) {
        return (_jsx("section", { className: "content-wrapper flex-fill", children: props.element }));
    }
    else {
        return _jsx(Navigate, { to: pathName, replace: true });
    }
};
export default PrivateRoute;
